const enum ObjectCategory {
  Tools = 'Tools',
  Museum = 'Museum'
}
export  default ObjectCategory;